



















































import {Component, Prop, PropSync, Vue} from 'vue-property-decorator';
import { DxValidationGroup } from 'devextreme-vue';

import DButton from '@/components/DButton/button.vue';
import DTextbox from '@/components/DTextbox/textbox.vue';
import DSelectbox from '@/components/DSelectbox/selectbox.vue';
import DTextarea from '@/components/DTextarea/textarea.vue';
import _ from 'lodash';
import DxPopup from 'devextreme-vue/popup';
import ElementTabs from "@/components/ElTabs/tabs.vue";
import DxSelectBox from "devextreme-vue/select-box";
import {DxCheckBox} from "devextreme-vue/check-box";
import EmailTemplateService from "@/services/email-template-service";
import DxTagBox from "devextreme-vue/tag-box";
import {confirm} from "devextreme/ui/dialog";
import EditPopup from './template-edit-popup.vue';

@Component({
  name: 'EmailTemplateBlock',
  components: {
    DxPopup,
    DxValidationGroup,
    DTextbox,
    DButton,
    DSelectbox,
    DTextarea,
    ElementTabs,
    DxSelectBox,
    DxCheckBox,
    DxTagBox,
    EditPopup,
  }
})

export default class extends Vue {

  public service = EmailTemplateService;

  public edit_popup: any = {
    visible: false,
    edit: false
  };



  created() {

  }

  onTemplateChange(e: any) {
    if (e.selectedItem?.id) {
      this.service.current = _.cloneDeep(e.selectedItem);
    }
    else {
      this.service.resetCurrent();
    }
  }

  onAdd() {
    this.edit_popup.edit = false;
    this.edit_popup.visible = true;
  }

  onEdit() {

    this.edit_popup.edit = true;
    this.edit_popup.visible = true;
  }

  onDelete() {
    if (this.service.current.id) {
      confirm(`Текущий шаблон будет удален. Выполнить удаление?`, 'Удаление шаблона')
        .then(async (answer: boolean) => {
          if (!answer) {
            //

          } else {
            let resp = await this.service.crud.delete(this.service.current.id);
            this.service.data_source.reload();
            this.service.resetCurrent();
          }
        });
    }
  }


  empty() {
    //
  }

}
